import { observable, IObservableArray } from "mobx";
import { BonusInfo } from "../BonusInfo";

export class PulseFreeBetInfo {
    marketTypeId: string;
    bonusInfo: IObservableArray<BonusInfo>;
    @observable selectedFreeBetId: string

    constructor(source: PulseFreeBetInfo) {
        this.marketTypeId = source.marketTypeId;
        this.bonusInfo = source.bonusInfo;
        this.selectedFreeBetId = source.selectedFreeBetId
    }
}